import axios from "axios";
import ApiReports from ".";
import { generateMessageReturn } from "../../../../utils/messageFuncs";

class ApiReportSOS extends ApiReports {
  basePathReport = "sos";

  compras = async (query: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${this.basePathReport}/compras/${query}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Relatório de SOS (Compras)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiReportSOS;
